export const GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC =
	"GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC";
export const GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC_SUCCESS =
	"GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC_SUCCESS";
export const GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC_ERROR =
	"GET_GEARBOX_BROKEN_PINION_STAGE3_DIAGNOSTIC_ERROR";

export const GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC =
	"GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC";
export const GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC_ERROR =
	"GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC_ERROR";
export const GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC_SUCCESS =
	"GET_GEARBOX_BROKEN_PINION_STAGE2_DIAGNOSTIC_SUCCESS";
